  <div *ngIf="!selectionService.selection.selected.length"  class="ddlLabel">No Documents Selected</div>
  <mat-error *ngIf="exportDownloadPath.errors?.pattern && (exportDownloadPath.dirty || exportDownloadPath.touched)" style="font-size: 12px; margin-bottom: 2px;">
    Invalid path. Please follow standard format i.e. '\\Amazon\D\Processing_Files\Job_Opportunity_Folder'
  </mat-error>
  <mat-form-field class="density-neg-1 show-no-errors">
    <input matInput placeholder="Folder Path:" [formControl]="exportDownloadPath" [pattern]="exportPattern">
  </mat-form-field>
  <button mat-button color="primary" [disabled]="!selectionService.selection.selected.length" (click)="downloadCase()">DOWNLOAD CASE</button>
  <mat-error *ngIf="exportLogPath.errors?.pattern && (exportLogPath.dirty || exportLogPath.touched)" style="overflow-wrap: break-word;">
    Invalid path. Please follow standard format i.e. '\\Amazon\D\Processing_Files\Job_Opportunity_Folder\filename.xlsx'
  </mat-error>
  <mat-form-field class="density-neg-1 show-no-errors">
    <input matInput [formControl]="exportLogPath" placeholder="File Path:" [pattern]="exportLogPattern">
  </mat-form-field>
  <button mat-button color="primary" [disabled]="!selectionService.selection.selected.length" (click)="downloadExcelLog()">DOWNLOAD LOG</button>
  <mat-form-field class="density-neg-1 show-no-errors">
    <mat-label>Copy To</mat-label>
    <mat-select [disabled]="!selectionService.selection.selected.length" (selectionChange)="setDestinationCase($event.value)">
      <mat-option *ngFor="let case of cases" [value]="case.caseId">{{case.caseName}} {{case.simpleCaseId}}</mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-button color="primary" [disabled]="!selectionService.selection.selected.length" (click)="copyCase()">COPY CASE</button>
